import React from 'react';
import PropTypes from 'prop-types';

import TextField from './text_field';

class PasswordConfirmationField extends TextField {
  constructor(props) {
    super(props);

    this.fieldType = 'password';
    this.validations.push(this.validateMatchesPassword);
    this.validateMatchesPassword = this.validateMatchesPassword.bind(this);
  }

  validateMatchesPassword(value) {
    if (value !== this.props.password) {
      return 'Passwords do not match';
    }
  }
}

PasswordConfirmationField.propTypes = {
  updateModel: PropTypes.func.isRequired,
  updateErrorMessage: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onValid: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  value: PropTypes.string,
  className: PropTypes.string,
  displayName: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export default PasswordConfirmationField;
